<template>
  <div class="booking-divider booking-divider-right">
    <div class="booking-content">
      <display-banner/>
      <div class="font-size-h2 text-header-color px-4 my-5 text-center">BOOKING PORTAL FOR NEW CLIENTS IS CURRENTLY NOT AVAILABLE.</div>
    </div>
  </div>
</template>

<script>
import DisplayBanner from '../DisplayBanner.vue'

export default {
  name: 'AnonymousBookingDisabled',
  components: {
    'display-banner': DisplayBanner
  }
}
</script>
